import React, { useState, useEffect, useContext } from "react";
import { Collapse, Card, CardHeader, CardBody, Badge } from "reactstrap";
import { FaPlus, FaMinus } from "react-icons/fa";
import Item from "./Item";
import { MenuContext } from "../MenuSnooze";

const menuSnoozeViewUtil = require("../menuSnoozeUtil");
const translator = require('../../../../utils/translator/translator');

function Category(
    { menuCategory }
)
{
    const [expanded, setExpanded] = useState(false);
    const [collapseOpen, setCollapseOpen] = useState(false);
    const { selectedMenu, snoozesMap } = useContext(MenuContext);
    useEffect(() =>
    {
        setCollapseOpen(expanded)
    }, [expanded])

    const icon = expanded ? <FaMinus /> : <FaPlus />;
    const snoozeOverview = !expanded && menuSnoozeViewUtil.getSnoozeDetailsForCategory(selectedMenu, snoozesMap, menuCategory);

    const handleHeaderClick = () =>
    {
        setExpanded(prevState => !prevState);
    }

    if (Array.isArray(menuCategory.items) && menuCategory.items.length > 0) 
    {
        return (
            <Card style={{ flex: "1 1 20%" }}>
                <CardHeader onClick={handleHeaderClick}>
                    <div className="d-flex gap-2 justify-content-start align-items-center">
                        <div>{icon}</div>
                        <div>{menuCategory.caption}</div>
                        {
                            !expanded &&
                            <>
                                <div>
                                    {snoozeOverview.noOfItemsSnoozed ?
                                        <h4 className="mb-0">
                                            <Badge className="text-dark item-badge">
                                                {snoozeOverview.noOfItemsSnoozed} {translator.getLabel("item_snoozed")}
                                            </Badge>
                                        </h4> :
                                        <></>
                                    }
                                </div>
                                <div>
                                    {snoozeOverview.noOfModifiersSnoozed ?
                                        <h4 className="mb-0">
                                            <Badge className="text-dark item-badge">
                                                {snoozeOverview.noOfModifiersSnoozed} {translator.getLabel("modifier_snoozed")}
                                            </Badge>
                                        </h4> :
                                        <></>
                                    }
                                </div>
                            </>
                        }
                    </div>
                </CardHeader>
                {
                    expanded &&
                    <Collapse isOpen={collapseOpen}>
                        <CardBody className="d-flex flex-column gap-2" style={{backgroundColor: '#b8dbf0'}}>
                            {
                                menuCategory.items.map(categoryItem => <Item key={categoryItem.id} item={categoryItem} isCategoryItem={true} />)
                            }
                        </CardBody>
                    </Collapse>
                }
            </Card>
        )
    }
    return (
        <Card>
            <CardHeader onClick={handleHeaderClick}>
                <div>{menuCategory.caption}</div>
            </CardHeader>
        </Card>
    )
}

export default Category;